<template>

</template>
<script>

export default {

    created() {

        //const event = new window.CustomEvent('modusign.end', { data: this.$route.params.path } )
        //window.opener.dispatchEvent(event)

        const params = new URL(window.location.href).searchParams;

        const eventType = params.get('eventType')

        window.opener.onModusignEnd( eventType )

        window.close()

    },
}

</script>